import { defineComponent } from 'vue'
import { useSmartBack } from '@/composables/use-smart-back'
import { NavBar as VanNavBar, Icon as VanIcon } from 'vant'
import { useSeo, useSiteBrand } from '@/composables/use-seo'
import { faqJsonLd } from '@/utils/seo'

// 帮助中心问答（与页面正文一致），用于生成 FAQPage 结构化数据
const HELP_FAQ = [
  {
    q: '查询助手能查询什么？',
    a: '选择条件可查询号码等条件的历史出现位置。目前提供的条件有：号码、生肖、五行、波色、家野、尾数。',
  },
  {
    q: '如何使用查询助手？',
    a: '点击查询助手右上方的“选择条件”按钮进行条件选择，选择后点击“确定”，系统会自动帮助您筛选条件的内容。',
  },
]

export default defineComponent({
  name: 'HelpPage',
  setup() {
  const goBack = useSmartBack()

    // SEO：帮助中心，输出 FAQPage 结构化数据（AI 引擎偏好问答对）。站点名取后台配置。
    const brand = useSiteBrand()
    useSeo({
      title: () => `帮助中心_查询助手使用说明 - ${brand.value}`,
      description: () =>
        `${brand.value}帮助中心：查询助手支持按号码、生肖、五行、波色、家野、尾数查询历史出现位置，附使用说明。`,
      keywords: () => `帮助中心,查询助手,使用说明,常见问题,${brand.value}`,
      jsonLd: () => faqJsonLd(HELP_FAQ),
    })

    return () => (
      <div class="help-wrap">
        <VanNavBar title="帮助中心">
          {{
            left: () => (
              <VanIcon name="arrow-left" color="#333" size="16" onClick={() => goBack()} />
            ),
          }}
        </VanNavBar>
        <h4 class="mt-[15px]">查询助手</h4>
        <p>
          选择条件可查询号码等条件的历史出现位置。目前提供的条件有：号码丶生肖丶五行丶波色丶家野丶尾数。
        </p>
        <h4>如何使用</h4>
        <p>
          点击查询助手右上方的"选择条件"按钮，进行条件选择。选择条件后点击"确定"后系统会自动帮助您筛选条件的内容。
        </p>
      </div>
    )
  },
})
